/**
 * 是否为函数
 * @param  {*} fn 对象
 * @return {Boolean}  是否函数
 */
import isType from './is-type';
export default (function (value) {
    return isType(value, 'Function');
});
//# sourceMappingURL=is-function.js.map